import { Pipe, PipeTransform } from '@angular/core';
import type { PrintMenu } from '../../../models/menu/print-menu';

@Pipe({
  name: 'printMenuBasicMethod',
  standalone: false
})
export class PrintMenuBasicMethodPipe implements PipeTransform {
  /**
   * @deprecated use MethodPipe instead
   */
  transform(printMenu: PrintMenu, methodKey: string, argument?: any): any {
    return printMenu?.[methodKey]?.(argument);
  }
}
